module.exports = require('./feedforwardNeuralNetwork');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fnn/src/index.js
 ** module id = 158
 ** module chunks = 0
 **/